import { useState } from "react";
import "./FAQSection.css";

const ITEMS = [
	{
		q: "What is BodhiStreams?",
		a: (
			<>
				BodhiStreams is a premium music streaming platform designed to provide a
				calm, grounded, and high-quality listening experience. We curate
				collections specifically for relaxation, meditation, and focus, offering
				an escape from the noise of everyday life.
			</>
		),
	},
	{
		q: "What are the differences between the membership plans?",
		a: (
			<>
				Our plans are designed to fit different listening needs. The{" "}
				<strong>Free</strong> plan lets you explore our basic collections. The{" "}
				<strong>Premium</strong> plans unlock the full library, higher audio
				quality, more streaming hours, and additional simultaneous devices.
				Check the comparison table above for the specifics of each tier.
			</>
		),
	},
	{
		q: "Can I cancel my subscription at any time?",
		a: (
			<>
				Yes, absolutely. You can manage your subscription directly through your
				profile page. If you cancel, your premium access continues until the end
				of the current billing period.
			</>
		),
	},
	{
		q: "How do the device limits work?",
		a: (
			<>
				Each membership tier comes with a "Simultaneous Devices" limit — the
				number of devices that can stream at the exact same time on your
				account. For example, a 2-device plan lets you listen on your phone and
				laptop at once.
			</>
		),
	},
	{
		q: "What happens if I reach my streaming hours limit?",
		a: (
			<>
				Some plans have a monthly cap on streaming hours to ensure fair usage
				and quality service for everyone. If you reach the limit, you can
				upgrade your plan or wait for the next billing cycle to reset.
			</>
		),
	},
	{
		q: "Do you offer refunds?",
		a: (
			<>
				We generally do not offer refunds for partial subscription periods. If
				you experience technical issues that prevent you from using the service,
				please contact support and we'll do our best to help.
			</>
		),
	},
];

const ChevronIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path
			d="M6 9l6 6 6-6"
			stroke="currentColor"
			strokeWidth="2.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const FAQSection = () => {
	const [openIndex, setOpenIndex] = useState(0);

	const toggle = (index) => {
		setOpenIndex((current) => (current === index ? -1 : index));
	};

	return (
		<section className="faq-section">
			<div className="faq-header">
				<h2 className="faq-title">Frequently Asked Questions</h2>
				<p className="faq-subtitle">
					Everything you need to know about BodhiStreams and our memberships.
				</p>
			</div>

			<div className="faq-list">
				{ITEMS.map((item, index) => {
					const isOpen = openIndex === index;
					return (
						<div key={item.q} className={`faq-item${isOpen ? " is-open" : ""}`}>
							<button
								type="button"
								className="faq-question"
								onClick={() => toggle(index)}
								aria-expanded={isOpen}
							>
								<span className="faq-question-text">{item.q}</span>
								<span className="faq-chevron">
									<ChevronIcon />
								</span>
							</button>
							<div className="faq-answer-wrap">
								<div className="faq-answer-inner">
									<p className="faq-answer">{item.a}</p>
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</section>
	);
};

export default FAQSection;
